import { CONFIRMATION_EMAIL_SENT, RESEND_EMAIL_CONFIRMATION_API_URL } from 'moduleBase/components/header/confirm-email-notifier/constants';

var confirmEmailSent = function confirmEmailSent() {
  return {
    type: CONFIRMATION_EMAIL_SENT
  };
};

var resendConfirmationEmail = function resendConfirmationEmail(networkService) {
  return networkService.post(RESEND_EMAIL_CONFIRMATION_API_URL, {});
};

var resendConfirmationEmailAction = function resendConfirmationEmailAction() {
  return function (dispatch, getState, _ref) {
    var networkService = _ref.networkService;
    return resendConfirmationEmail(networkService).then(function (response) {
      dispatch(confirmEmailSent());
      return response;
    });
  };
};

export { resendConfirmationEmailAction };